import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { CategoryState, UserState } from '@/states'
import { List } from '@/controllers/category'

const useCategories = () => {
    const { SetState, Loading } = CategoryState()
    const { User } = UserState()
    const { push, pathname } = useRouter()

    useEffect(() => {
        if (User && !Loading) List(SetState, push)
    }, [User, pathname])
}

export default useCategories
